import { acceptHMRUpdate, defineStore } from 'pinia'

export const useUserStore = defineStore('user', {
  persist: {
    storage: piniaPluginPersistedstate.cookies({
      maxAge: 60 * 60 * 24 * 365,
    }),
  },
  
  state: () => ({
    id: null,
    token: null,
    email: null,
    favoriteId: null,
    favorites: [],
  }),

  getters: {
    authed() {
      return true // Fake authed
    },

    favorite() {
      return this.favorites
        ?.find(favorite => favorite.id === this.favoriteId)
    },

    favoriteIds() {
      return this.favorites
        ?.map(favorite => favorite.id) ?? []
    },
  },

  actions: {
    reset() {
      this.$reset()
    },

    logOut() {
      const email = this.email
      this.$reset()
      this.email = email
    },

    // 
    // Handle favorites
    // 
    selectFavorite(team) {
      this.addFavorite(team)
      this.favoriteId = team.id
    },

    addFavorite(team) {
      const teamObj = structuredClone({
        id: team.id,
        slug: team.slug,
        name: team.name,
        abbr: team.abbr,
        logo: team.logo,
        theme: {
          text: team.theme?.text || null,
          base: team.theme?.base || null,
          accent: team.theme?.accent || null,
        },
      })
      this.favorites = useUniqueBy([...this.favorites, teamObj], 'id')
    },

    removeFavorite(team) {
      this.favorites = this.favorites.filter(favorite => favorite.id !== team.id)
    },

    toggleFavorite(team) {
      this.favoriteIds.includes(team.id)
        ? this.removeFavorite(team)
        : this.selectFavorite(team)
    },
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useUserStore, import.meta.hot))
}
